import { render, staticRenderFns } from "./PagespeedReport.vue?vue&type=template&id=1137989c&scoped=true&"
import script from "./PagespeedReport.vue?vue&type=script&lang=js&"
export * from "./PagespeedReport.vue?vue&type=script&lang=js&"
import style0 from "./PagespeedReport.vue?vue&type=style&index=0&id=1137989c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1137989c",
  null
  
)

export default component.exports